<div fxLayout="column">
  <mat-form-field>
    <mat-label class="select-placeholder-container">
      {{ valuesDescription | translate }}
      <mat-spinner *ngIf="loadingFilters" class="spinner" diameter="20"></mat-spinner>
    </mat-label>
    <mat-select (selectionChange)="onValueSelected($event)" [formControl]="selectValueControl">
      <mat-select-trigger *ngIf="this.currentValue">{{ currentValue.name }}</mat-select-trigger>
      <mat-option *ngIf="groupedValues && groupedValues.length > 0" class="empty-mat-option"></mat-option>
      <mat-optgroup *ngFor="let group of groupedValues" [label]="group.groupName | translate" [style]="getMatOptGroupStyle(group)">
        <mat-option *ngFor="let value of group.values" [value]="value" [ngClass]="{ 'mat-option-with-delete-button' : group.allowDeleteValues }">
          <div class="select-list-option">
            <span>{{ value.name }}</span>
            <button mat-icon-button *ngIf="group.allowDeleteValues" (click)="onDeleteValue($event, value)">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </div>
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>
</div>